module.exports = __webpack_public_path__ + "img/course120.f8454ddd.png";